import type { PatientId, PatientSourceIdentity } from "./patient.model";
import type { RelatedPersonDetails } from "./related-person.model";

export type RegistrationRelatedPerson = RelatedPersonDetails & {
  id: string;
  isEmergencyContact: boolean;
  portalAccess?: boolean;
};

/** Discovery candidates, with the server's grade treated as evidence, never authority. */
export interface PatientMatchCandidate {
  patientId?: PatientId;
  patientLocator?: string;
  grade: string;
  birthDate?: string;
}

export type PatientMatchDecision =
  | { kind: "new" }
  | { kind: "link"; patientId: PatientId }
  | { kind: "review"; candidates: PatientMatchCandidate[] };

export const ACQUISITION_SOURCES = ["crm", "in-app"] as const;
export type CaseAcquisition = { source: (typeof ACQUISITION_SOURCES)[number] };
export interface RegistrationReview {
  sourceIdentity: PatientSourceIdentity;
  acquisition?: CaseAcquisition;
  relatedPerson?: RegistrationRelatedPerson;
  candidates: PatientMatchCandidate[];
  resolution?: { kind: "link" | "different-person"; patientId: PatientId; uncheckedCandidateIndexes?: number[] };
}
